/**
 * 接口文档
 * https://shopline.yuque.com/ruzrfv/az7khs/pty9ui
 */
export default {
  /** 创建商品 */
  createGoods: '/api/skus/create',
  /** 删除商品 */
  deleteGoods: '/api/skus/delete',
  /** 更新商品 */
  updateGoods: '/api/skus/update',
  /**查询商品列表 */
  searchGoods: '/api/skus/search',
  /**查询商品详情 */
  getGoodDetail: '/api/skus/get',
  /** 获取oss上传地址及参数*/
  getUploadTarget: '/api/tasks/sign',
  /**批量导入 */
  batchImport: '/api/tasks/import',
  /** 同步商品 */
  orderSync: '/api/tasks/sku-sync',
  /** 校验id是否可用 */
  skusCheckId: 'api/skus/exist-id',
  /** 校验商品是否可删除 */
  validateDelete: '/api/skus/validate-delete',
  /** 删除商品 */
  deleteGood: '/api/skus/delete',
  /** 停用/启用商品 */
  setGoodsStatus: '/api/skus/status',
  /** 批量停用/启用商品 */
  batchSetGoodsStatus: '/api/skus/batch-status',

  /** 批量更新商品 */
  batchUpdateGoods: '/api/skus/batch-update',

  /** 批量删除商品 */
  batchDeleteGoods: '/api/skus/batch-delete',
}
